import { ANSWER_BUTTON_COLOR } from '@lib/constants/quizzes'
import { animated, useSpring } from '@react-spring/web'
import { useEffect } from 'react'

type Props = {
  isAnswerValidated: boolean
  isCorrect: boolean
}

const ResultBottomBar = ({ isAnswerValidated, isCorrect }: Props) => {
  const [bottomStatusCardStyle, bottomStatusCardAnimationAPI] = useSpring(
    () => ({
      from: { y: 100 },
      reset: true,
    })
  )

  useEffect(() => {
    isAnswerValidated &&
      bottomStatusCardAnimationAPI
        .update({
          to: async (next, _) => {
            await next({ y: 0 })
            await next({ delay: 1500 })
            await next({ y: 100 })
          },
        })
        .start()
  }, [isAnswerValidated])

  return (
    <animated.div
      style={{
        ...bottomStatusCardStyle,
        backgroundColor: isCorrect
          ? ANSWER_BUTTON_COLOR.correct
          : ANSWER_BUTTON_COLOR.wrong,
      }}
      className="flex items-end justify-center pb-5 h-20 absolute w-full bottom-0 font-600"
    >
      {isCorrect ? 'CORRECT' : 'WRONG ANSWER'}
    </animated.div>
  )
}

export default ResultBottomBar
